/* eslint-disable */

import * as Apollo from '@apollo/client';
import { DocumentNode } from 'graphql';
import * as Types from '@99designs/graph-utils/types';

export type ExpertServicePrintProductsQueryVariables = Types.Exact<{
    mpvId: Types.Scalars['String'];
}>;

export type ExpertServicePrintProductsQuery = {
    __typename: 'Query';
    expertServices: Array<{
        __typename: 'ExpertService';
        printProduct: Types.Maybe<{ __typename: 'PrintProduct'; mpvId: string; name: string }>;
    }>;
};

export const ExpertServicePrintProductsDocument: DocumentNode = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'ExpertServicePrintProducts' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'mpvId' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'expertServices' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'mpvIds' },
                                value: {
                                    kind: 'ListValue',
                                    values: [
                                        {
                                            kind: 'Variable',
                                            name: { kind: 'Name', value: 'mpvId' },
                                        },
                                    ],
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'printProduct' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'mpvId' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'name' },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};

/**
 * __useExpertServicePrintProductsQuery__
 *
 * To run a query within a React component, call `useExpertServicePrintProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useExpertServicePrintProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExpertServicePrintProductsQuery({
 *   variables: {
 *      mpvId: // value for 'mpvId'
 *   },
 * });
 */
export function useExpertServicePrintProductsQuery(
    baseOptions: Apollo.QueryHookOptions<
        ExpertServicePrintProductsQuery,
        ExpertServicePrintProductsQueryVariables
    >
) {
    return Apollo.useQuery<
        ExpertServicePrintProductsQuery,
        ExpertServicePrintProductsQueryVariables
    >(ExpertServicePrintProductsDocument, baseOptions);
}
export function useExpertServicePrintProductsLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        ExpertServicePrintProductsQuery,
        ExpertServicePrintProductsQueryVariables
    >
) {
    return Apollo.useLazyQuery<
        ExpertServicePrintProductsQuery,
        ExpertServicePrintProductsQueryVariables
    >(ExpertServicePrintProductsDocument, baseOptions);
}
export type ExpertServicePrintProductsQueryHookResult = ReturnType<
    typeof useExpertServicePrintProductsQuery
>;
export type ExpertServicePrintProductsLazyQueryHookResult = ReturnType<
    typeof useExpertServicePrintProductsLazyQuery
>;
export type ExpertServicePrintProductsQueryResult = Apollo.QueryResult<
    ExpertServicePrintProductsQuery,
    ExpertServicePrintProductsQueryVariables
>;
